import { DateUtil, isNullOrUndefined } from '@uzurv/core';
import { autoserialize, autoserializeAs } from 'cerialize';
import { OperationsAlertObjectInfo } from './operations-alert-object-info';

export class OperationsAlertRideInfo extends OperationsAlertObjectInfo {
  @autoserialize
  transitProgramCode: string;

  @autoserialize
  riderName: string;

  @autoserializeAs(Date)
  pickupDate: Date;

  @autoserialize
  onDemand: boolean;

  static OnSerialized(instance: OperationsAlertRideInfo, json: any): void {
    if (!isNullOrUndefined(instance.pickupDate)) {
      json.pickupDate = DateUtil.serializeDate(instance.pickupDate);
    }
  }

  static OnDeserialized(instance: OperationsAlertRideInfo, json: any): void {
    if (!isNullOrUndefined(json['pickupDate'])) {
      instance.pickupDate = DateUtil.deserializeDate(json['pickupDate']);
    }
  }
}
